import React from 'react';
import "./UserLists.css";
import AppAdminList from "./AppAdminList.mjs";
import UserShortList from "./UserShortList.mjs";
import UserLongList from "./UserLongList.mjs";
import UserPublicTeamList from "./UserPublicTeamList.mjs";

export default function UserLists({app_user}) 
{
    if (!app_user) return;
    
    return (
        <>
            <div class="sticky">
                <ol class="list-group mt-2">
                    <AppAdminList user_id={app_user.UserID} />
                    <UserShortList user_id={app_user.UserID} />
                    <UserLongList team_id={app_user.PrivateTeamID} />
                    <UserPublicTeamList user_id={app_user.UserID} />
                </ol>
            </div>
        </>
    );
}